import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-report-for-products-form',
  templateUrl: './service-report-for-products-form.component.html',
  styleUrls: ['./service-report-for-products-form.component.css']
})
export class ServiceReportForProductsFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
